import {APIStatus, PayMoneyUserStatus, PayMoneyUserStatusList, PayMethod, NaverPointStatus} from '@web/core/constants'
import {getNaverPayPointByApi} from '@web/pageHelpers/ordersheet'
import {getNaverPayPointAmount} from '@web/slices/pointPayment/slice'
import makeSlice from '@web/slices/pointPayment/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {data, availablePayMethodTypes} = payload

            const {
                rewardPoint,
                chargePoint,
                usePointAll,
                exposeAmlGuideMessage,
                pointExhaustionListAvailable,
                preferredPointExhaustionList,
            } = data.naverpayPoint ?? getNaverPayPointByApi()

            const isPayMoneyUser = PayMoneyUserStatusList.includes(
                chargePoint?.chargePointUser?.userStatus ?? PayMoneyUserStatus.NOT_OPEN,
            )

            state.naverPayPoint.amount = getNaverPayPointAmount({
                rewardPoint: rewardPoint?.rewardPointBalance ?? 0,
                chargePoint: chargePoint?.chargePointBalance?.availableBalance ?? 0,
                isPayMoneyUser,
            })

            state.naverPayPoint.preferredPoint = {
                sequences: preferredPointExhaustionList,
                apiStatus: pointExhaustionListAvailable ? APIStatus.RESOLVED : APIStatus.REJECTED,
            }

            /**
             * 페이머니 유저상태는 재조회 불가 (24.12.17)
             * 재조회 가능 스펙 추가 시 status 필드 반영 검토 필요
             */
            const isNaverPointAvailable = isPayMoneyUser
                ? availablePayMethodTypes.includes(PayMethod.REWARD_POINT)
                : (availablePayMethodTypes.includes(PayMethod.REWARD_POINT) ||
                      availablePayMethodTypes.includes(PayMethod.CHARGE_POINT)) &&
                  chargePoint.chargePointUser.resultType === 'SUCCESS'

            if (isNaverPointAvailable) {
                state.naverPayPoint.status = NaverPointStatus.ENABLE
                state.naverPayPoint.usePointAll = usePointAll
            } else {
                state.naverPayPoint.status = NaverPointStatus.NEVER
            }
            state.exposeAmlGuideMessage = exposeAmlGuideMessage
        })
    },
})

export default slice.reducer
